import { CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { environment } from '@env/environment';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JournalMainGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(): Observable<boolean> {
    if (!environment.feature.journal_main) {
      this.router.navigate(['/']);
      return of(false);
    }
    return of(true);
  }
}
